module.exports = __webpack_public_path__ + "media/images/bg01-f9870f9f084eddbb09bf87d335b6da4d.png";